/**
 * Função utilitária para adicionar um atraso.
 * @param {number} ms - O tempo de atraso em milissegundos.
 * @returns {Promise} - Uma promise que resolve após o atraso.
 */
export default function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}
